import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useState, useEffect } from 'react';


interface AddressBlockProps {
    formPrefix: string;
    outputMonth: (month: number) => void;
    outputYear: (year: number) => void;
    outputDay: (day: number) => void;
}

const getDaysInMonth = (year: number, month: number) => new Date(year, month, 0).getDate();

function DateBlock({formPrefix, outputYear, outputMonth, outputDay}: AddressBlockProps){
    var today = new Date();
    const currentYear = today.getFullYear()
    const years = Array.from({ length: 110 }, (v, i) => currentYear - i);
    const initYear = today.getFullYear()
    const initMonth = today.getMonth()
    const initDay = today.getDay()

    let [year, setYear] = useState(initYear);
    let [month, setMonth] = useState((initMonth + 1 ));
    let [day, setDay] = useState(initDay);

    let daysList = Array.from({ length: getDaysInMonth(initYear, initMonth) }, (v, i) => 1 + i);

    const updateParentState = () => {
        outputYear(year);
        outputMonth(month);
        outputDay(day);
    }
    const updatedays = () => {
        daysList = Array.from({ length: getDaysInMonth(Number(year), Number(month)) }, (v, i) => currentYear + i);
        setDay(1)
    }

    const yearUpdate = (year: number) : void => {
        setYear(year); 
        updatedays();
    }

    const monthUpdate = (month: number) : void => {
        setMonth(month);
        updatedays();
    }

    const dayUpdate = (day: number) : void => {
        setDay(day);
    }

    /* Component Init */
    useEffect(() => {
        updateParentState();
    }, [year, month, day]);

    return (
        <> 
            <Container>
                <Row className="">
                    <Col xs={{span: 4}}>
                        <select id={formPrefix + "_year"} className="border-0 input-fill no-generic-input-styles" aria-describedby="dob_year" value={year} onChange={(e) => yearUpdate(Number(e.target.value))}>
                               {years.map( (item) => <option key={item} value={item} className="dropdown-item" >{item}</option>)}
                        </select>
                    </Col>
                    <Col>
                            <select id={formPrefix + "_month"} className="border-0 input-fill no-generic-input-styles" aria-describedby="dob_month" value={month} onChange={(e) => monthUpdate(Number(e.target.value))}>
                                <option value="1" className="dropdown-item" >January</option>
                                <option value="2" className="dropdown-item" >February</option>
                                <option value="3" className="dropdown-item" >March</option>
                                <option value="4" className="dropdown-item" >April</option>
                                <option value="5" className="dropdown-item" >May</option>
                                <option value="6" className="dropdown-item" >June</option>
                                <option value="7" className="dropdown-item" >July</option>
                                <option value="8" className="dropdown-item" >August</option>
                                <option value="9" className="dropdown-item" >September</option>
                                <option value="10" className="dropdown-item" >October</option>
                                <option value="11" className="dropdown-item" >November</option>
                                <option value="12" className="dropdown-item" >December</option>
                            </select>
                    </Col>
                    <Col xs={{span: 3}}>
                        <select id={formPrefix + "_day"} className="border-0 input-fill no-generic-input-styles" aria-describedby="dob_day" value={day} onChange={(e) => dayUpdate(Number(e.target.value))}>
                                {daysList.map((item) => <option key={item} value={item} className="dropdown-item" >{item}</option>)}
                        </select>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default DateBlock;